import React from "react";

export const colorContext = React.createContext("#01A2E8");